import { FC } from "react";
import { ReactComponent as ActiveSVG } from "go-list/core/images/statuses/active.svg";
import { ReactComponent as DeletedSVG } from "go-list/core/images/statuses/disabled.svg";
import { ReactComponent as NewSVG } from "go-list/core/images/statuses/dismissed.svg";
import { ReactComponent as InactiveSVG } from "go-list/core/images/statuses/warning.svg";

interface Props {
	status?: string;
}

const AppStatus: FC<Props> = ({ status }) => {
	switch (status) {
		case "NEW":
			return <InactiveSVG className={"me-2"} />;
		case "DELETED":
		case "ERROR":
			return <DeletedSVG className={"me-2"} />;
		case "ENABLED":
			return <ActiveSVG className={"me-2"} />;
		default:
			return <NewSVG className={"me-2"} />;
	}
};

export default AppStatus;
